import RefoxCaseMain from '@/components/RefoxCaseMain'
const RefoxCase = () => {
    const element = (<>
        <RefoxCaseMain />
    </>)
    return element
}
export default RefoxCase